import { translatedMessage } from "../service/LanguageService";

const RecruitmentUtils = {

  canValidate(recruitmentPlan) {
    if (recruitmentPlan.status === 'DRAFT') {
      return true;
    }

    return false;
  },

  canMoveToDraft(recruitmentPlan) {
    if (recruitmentPlan.status === 'VALIDATED' || recruitmentPlan.status === 'INVALIDATED') {
      return true;
    }

    return false;
  },

  canEditInstitution(recruitmentPlan) {
    if (recruitmentPlan.status === 'DRAFT') {
      return true;
    }

    return false;
  },

  canChangeFiles(recruitmentPlan, usageCode) {
    if (recruitmentPlan.status === 'VALIDATED') {
      return true;
    }

    if(recruitmentPlan.status === 'FINALIZED' && usageCode === 'NomFileUsageRecruitmentPlanInvalidation') {
      return true;
    }

    return false;
  },

  canInValidate(recruitmentPlan) {
    if (recruitmentPlan.status === 'FINALIZED') {
      return true;
    }

    return false;
  },

  trimesterDropdownOptions() {
    return [
      { label: translatedMessage('trimester.1'), value: 1 },
      { label: translatedMessage('trimester.2'), value: 2 },
      { label: translatedMessage('trimester.3'), value: 3 },
      { label: translatedMessage('trimester.4'), value: 4 }
    ];
  },

  semesterDropdownOptions() {
    return [
      { label: translatedMessage('semester.1'), value: 1 },
      { label: translatedMessage('semester.2'), value: 2 }
    ];
  },


  yesNoDropdownOptions() {
    return [
      { label: translatedMessage('generic.yes'), value: true },
      { label: translatedMessage('generic.no'), value: false }
    ];
  },

  getRecruitmentPlanJobType: () => {
    return {
      EXECUTIE: "EXECUTIE",
      CONDUCERE: "CONDUCERE",
      INALTI_FUNCTIONARI_PUBLICI: "INALTI_FUNCTIONARI_PUBLICI",
      PROMOVARE_CONDUCERE: "PROMOVARE_CONDUCERE"
    };
  },

  institutionJobToRecruitmentPlanJob: (institutionJob, recruitmentJob) => {
    if(recruitmentJob.type !== "INALTI_FUNCTIONARI_PUBLICI") {
      recruitmentJob.departmentName = institutionJob.departmentName
      recruitmentJob.departmentType = institutionJob.departmentType
      recruitmentJob.positionClass = institutionJob.positionClass
      recruitmentJob.positionLevel = institutionJob.positionLevel        
    }
    recruitmentJob.position = institutionJob.position
    recruitmentJob.jobID = institutionJob
    recruitmentJob.jobList = [institutionJob]

    return recruitmentJob
  },

  hideField: (type) => {
    return type === "INALTI_FUNCTIONARI_PUBLICI"
  },

};

export default RecruitmentUtils;